export enum ButtonVariant {
    Contained = 'contained',
    Outlined = 'outlined',
    Text = 'text',
}
